module.exports = __webpack_public_path__ + "img/softgrove-1.1a577da2.jpeg";